export function getChannel(component) {
  return component.constructor.name;
}
